/** Locomotion clip selection from sim state (blend-tree lite; the full tree arrives in Phase 3). */

export type LocomotionClip = 'Idle' | 'Walk' | 'Run' | 'Jump';

export interface LocomotionInput {
  /** Planar speed in m/s. */
  speed: number;
  grounded: boolean;
  boosting: boolean;
  walkSpeed: number;
  boostSpeed: number;
}

export interface LocomotionChoice {
  clip: LocomotionClip;
  /** Playback rate so the stride roughly matches the ground speed. */
  timeScale: number;
}

const WALK_CYCLE_SPEED = 4.5;
const RUN_CYCLE_SPEED = 9;

export function selectLocomotion(i: LocomotionInput): LocomotionChoice {
  if (!i.grounded) return { clip: 'Jump', timeScale: 1 };
  if (i.speed < 0.3) return { clip: 'Idle', timeScale: 1 };
  if (i.boosting || i.speed > i.walkSpeed * 0.75) {
    return { clip: 'Run', timeScale: clamp(i.speed / RUN_CYCLE_SPEED, 0.8, 1.9) };
  }
  return { clip: 'Walk', timeScale: clamp(i.speed / WALK_CYCLE_SPEED, 0.6, 1.5) };
}

function clamp(v: number, lo: number, hi: number): number {
  return Math.min(hi, Math.max(lo, v));
}
